var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _ellipse3, _ellipse4, _path5, _path6, _ellipse5, _ellipse6, _g, _mask, _g2, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLrainN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 434,
    height: 532,
    fill: "none",
    viewBox: "0 0 434 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter0_f_30_560)",
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial_30_560)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M263.874 497.912C259.621 506.773 251 512.835 241.057 512.835C226.897 512.835 215.418 500.541 215.418 485.375C215.418 483.2 215.645 481.002 216.076 478.769C214.012 484.048 212.854 489.085 212.854 494.001C212.854 509.167 224.333 521.461 238.493 521.461C251.414 521.461 262.102 511.225 263.874 497.912Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial_30_560)",
    d: "M263.876 493.865C263.876 509.031 252.397 521.325 238.237 521.325C224.077 521.325 212.597 509.031 212.597 493.865C212.597 478.699 223.622 462.38 238.237 441.389C250.544 461.804 263.876 478.699 263.876 493.865Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.775,
    cy: 471.293,
    fill: "url(#paint2_radial_30_560)",
    rx: 26.28,
    ry: 28.754
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.904,
    cy: 502.635,
    fill: "url(#paint3_radial_30_560)",
    rx: 26.28,
    ry: 28.754
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter1_f_30_560)",
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_radial_30_560)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M189.025 424.194C185.227 431.593 177.53 436.654 168.652 436.654C156.009 436.654 145.76 426.389 145.76 413.726C145.76 411.91 145.962 410.075 146.347 408.211C144.505 412.618 143.471 416.824 143.471 420.929C143.471 433.591 153.72 443.856 166.363 443.856C177.899 443.856 187.442 435.31 189.025 424.194Z",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial_30_560)",
    d: "M189.026 420.815C189.026 433.478 178.777 443.743 166.134 443.743C153.491 443.743 143.242 433.478 143.242 420.815C143.242 408.152 153.085 394.526 166.134 377C177.122 394.046 189.026 408.152 189.026 420.815Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.971,
    cy: 401.969,
    fill: "url(#paint6_radial_30_560)",
    rx: 23.465,
    ry: 24.008
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.694,
    cy: 428.138,
    fill: "url(#paint7_radial_30_560)",
    rx: 23.465,
    ry: 24.008
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter2_f_30_560)",
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_radial_30_560)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M333.52 424.194C329.723 431.592 322.025 436.654 313.148 436.654C300.505 436.654 290.255 426.389 290.255 413.726C290.255 411.91 290.458 410.074 290.843 408.21C289 412.618 287.966 416.824 287.966 420.928C287.966 433.591 298.215 443.856 310.858 443.856C322.394 443.856 331.938 435.31 333.52 424.194Z",
    clipRule: "evenodd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_radial_30_560)",
    d: "M333.521 420.815C333.521 433.478 323.272 443.743 310.629 443.743C297.986 443.743 287.737 433.478 287.737 420.815C287.737 408.152 297.581 394.526 310.629 377C321.618 394.046 333.521 408.152 333.521 420.815Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.467,
    cy: 401.969,
    fill: "url(#paint10_radial_30_560)",
    rx: 23.465,
    ry: 24.008
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.189,
    cy: 428.138,
    fill: "url(#paint11_radial_30_560)",
    rx: 23.465,
    ry: 24.008
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_30_560)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_30_560)",
    fillRule: "evenodd",
    d: "M341.51 1.08608C336.359 0.370134 331.096 0 325.747 0C263.345 0 212.759 50.368 212.759 112.5C212.759 174.632 263.345 225 325.747 225C372.68 225 412.929 196.509 430 155.95C428.899 155.983 427.793 156 426.683 156C369.69 156 323.487 111.676 323.487 57C323.487 36.2527 330.14 16.996 341.51 1.08608Z",
    clipRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1_30_560",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 367L150.358 367C67.3176 367 0 299.843 0 217C0 134.157 67.3176 67 150.358 67C217.131 67 273.738 110.423 293.354 170.507C301.767 168.22 310.622 167 319.761 167C375.122 167 420 211.772 420 267C420 322.228 375.122 367 319.761 367Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_30_560)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_30_560)",
    fillRule: "evenodd",
    d: "M319.761 367L150.358 367C67.3176 367 0 299.843 0 217C0 134.157 67.3176 67 150.358 67C217.131 67 273.738 110.423 293.354 170.507C301.767 168.22 310.622 167 319.761 167C375.122 167 420 211.772 420 267C420 322.228 375.122 367 319.761 367Z",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 367V366V367ZM319.761 367V368V367ZM293.354 170.507L292.403 170.817L292.698 171.721L293.616 171.472L293.354 170.507ZM150.358 368L319.761 368V366L150.358 366V368ZM-1 217C-1 300.397 66.7675 368 150.358 368V366C67.8676 366 1 299.288 1 217H-1ZM150.358 66C66.7675 66 -1 133.603 -1 217H1C1 134.712 67.8676 68 150.358 68V66ZM294.304 170.196C274.558 109.712 217.575 66 150.358 66V68C216.687 68 272.918 111.133 292.403 170.817L294.304 170.196ZM293.616 171.472C301.945 169.208 310.711 168 319.761 168V166C310.532 166 301.59 167.232 293.091 169.542L293.616 171.472ZM319.761 168C374.572 168 419 212.326 419 267H421C421 211.217 375.672 166 319.761 166V168ZM419 267C419 321.674 374.572 366 319.761 366V368C375.672 368 421 322.783 421 267H419Z",
    mask: "url(#path-14-inside-1_30_560)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_30_560",
    width: 67.02,
    height: 58.692,
    x: 204.854,
    y: 470.769,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_560",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_30_560",
    width: 61.554,
    height: 51.646,
    x: 135.471,
    y: 400.211,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_560",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_30_560",
    width: 61.554,
    height: 51.646,
    x: 279.966,
    y: 400.21,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_560",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_30_560",
    width: 246.241,
    height: 240,
    x: 187.759,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_30_560"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_560",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -25,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.529412 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect2_innerShadow_30_560"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_30_560",
    width: 420,
    height: 348.647,
    x: 0,
    y: 67,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_30_560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(238.493 495.87) rotate(-40.9122) scale(44.7839 32.9571)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(238.237 495.734) rotate(-40.9122) scale(44.7839 32.9571)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(244.775 471.293) rotate(58.9731) scale(39.2592 10.9306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(228.494 502.635) rotate(52.9232) scale(21.2638 10.0805)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(166.363 422.489) rotate(-39.0214) scale(38.8946 28.2895)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(166.134 422.376) rotate(-39.0214) scale(38.8946 28.2895)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(171.971 401.969) rotate(57.2503) scale(33.3987 9.57856)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(157.435 428.138) rotate(51.0597) scale(18.2114 8.77451)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(310.858 422.489) rotate(-39.0217) scale(38.8948 28.2897)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(310.629 422.376) rotate(-39.0214) scale(38.8946 28.2895)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(316.467 401.969) rotate(57.2503) scale(33.3987 9.57856)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_30_560",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(301.93 428.138) rotate(51.0597) scale(18.2114 8.77451)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_30_560",
    x1: 225.564,
    x2: 388.013,
    y1: 0,
    y2: 257.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B87EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#3010AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_30_560",
    x1: 29.423,
    x2: 419.459,
    y1: 67,
    y2: 367.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLrainN);
export default __webpack_public_path__ + "static/media/LrainN.b386e505158a63a591b5374600255efe.svg";
export { ForwardRef as ReactComponent };